import React, { PureComponent } from 'react';
import WND from './WND.js';
import ICONS from './ICONS';
import BTNGROUP from './BTNGROUP.js';
import './MSGBOX.css';

class MSGBOX extends WND {
    applicationContent() {
        let buttons = {};
        for (var b in this.props.buttons) {
            let original = this.props.buttons[b];
            buttons[b] = () => {
                this.dismiss();
                original();
            };
        }

        return <div className="message-box">
            <div className="contents">
                {this.props.icon ? <div className="icon" style={{backgroundImage: "url(" + this.props.icon + ")"}}></div> : null}
                <div className="message">{this.shortenedText ? this.shortenedText : this.props.message}</div>
            </div>
            <BTNGROUP buttons={buttons} />
        </div>;
    }

    shortenText(n) {
        var lines = this.props.message.split("\n");
        let maxLineLen = Math.max.apply(null, lines.map((l) => l.length));

        let splitLine = (line) => {
            var split = 1;
            for (var i = 0; i < line.length; i += 1) {
                if (i >= maxLineLen * (split / n) && line[i] == " ") {
                    line = line.slice(0, i + 1) + "\n" + line.slice(i + 1);
                    split += 1;
                    i += 1;
                }
            }
            return line;
        }

        return lines.map(splitLine).join("\n");
    }

    dismiss() {
        window.WINAPI.CloseWindow(this.props.hwnd);
    }

    icon() {
        return null;
    }

    title() {
        return this.props.title;
    }

    appearOnTaskbar() {
        return false;
    }

    defaultPosition() {
        return 'center';
    }

    defaultSize() {
        let hasIcon = this.props.icon;

        let xAdd = 12 + 12;
        let yAdd = 26 + 12 + 15 + 23 + 12;

        let computeSize = (text) => {
            let e = document.getElementsByClassName("message-box-fake-elm");
            if (e.length > 0) {
                e[0].remove();
            }
            let fakeElem = document.createElement("div");
            fakeElem.className = "message-box-fake-elm";
            fakeElem.innerHTML = text;
    
            document.body.appendChild(fakeElem);
            console.log(fakeElem.clientWidth + " x " + fakeElem.clientHeight);
            let dimens = {w: fakeElem.clientWidth + (hasIcon ? (xAdd + 32 + 15) : xAdd), h: fakeElem.clientHeight + yAdd};
            fakeElem.parentNode.removeChild(fakeElem);
            dimens.w = Math.max(dimens.w, 190); // fit 2 buttons
            return dimens;
        };

        var dimens = computeSize(this.props.message);
        var n = 0;
        this.shortenedText = null;

        while (dimens.w > (window.innerWidth - 100)) {
            n += 1;

            if (n > 3) {
                break;
            }

            this.shortenedText = this.shortenText(n);

            dimens = computeSize(this.shortenedText);
        }

        if (hasIcon) {
            dimens.h = Math.max(dimens.h, 32 + yAdd);
        }
        

        return dimens;
    }

    resizable() {
        return false;
    }

    canMinimize() {
        return false;
    }
}

export default MSGBOX;


// WEBPACK FOOTER //
// ./src/walleris/MSGBOX.js